import { accountsTypes } from '../../../content/accountsTypes';
import GDriveIcon from '../../../images/accounts-icons/google-drive-icon.svg';
import GLogo from '../../../images/googleGLogo.svg';
import styled from 'styled-components';

const Img = styled.img`
  width: 24px;
  @media all and (min-width: 768px) {
    width: 46px;
  }
  &.small{
    width: 24px;
  }
  &.med{
    width: 32px;
  }
  &.large{
    width: 72px;
  }
`
interface EntityIconProps {
  entityName: string,
  size?: 'small' | 'large' | 'medium' | 'med',
  showGLogo?: boolean,
}

const EntityIcon = ({entityName, size, showGLogo} : EntityIconProps) => {
  const icon = accountsTypes.find(acc => acc.shortName === entityName);
  if (showGLogo && (entityName === 'gdrive' || entityName === 'gmail')) {
    return <Img src={GLogo} alt={`${entityName} Icon`} className={size || 'medium'} />
  }
  if (entityName === 'gdrive') {
    return <Img src={GDriveIcon} alt={`${entityName} Icon`} className={size || 'medium'} />
  }
  return (
    <Img src={icon?.icon.default} alt={`${entityName} Icon`} className={size || 'medium'} />
  )
}

export default EntityIcon;